module.exports = __webpack_public_path__ + "static/dojazd-photo02-11c2f33f9feae7794d19028dd84b85e6.jpg";